/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import '@airglow/prefab-table';

import prefabFactory from '@airglow/prefab';
import { selectSearchFilteredSessions } from '../selectors';

const nameSorter = R.curry((sortBy, direction, a, b) => {
  const aName = `${a.firstName} ${a.lastName}`;
  const bName = `${b.firstName} ${b.lastName}`;
  return (aName < bName ? -1 : aName > bName ? 1 : 0) * direction;
});

const prefabs = prefabFactory({
  sessionsTable: {
    type: 'table',
    allowsMultipleSelection: true,
    dataSelector: selectSearchFilteredSessions,
    columns: {
      name: {
        sorter: 'default'
      },
      createdById: {
        sorter: nameSorter
      },
      createdTs: {
        sorter: 'default'
      }
    },
    defaultSort: {
      column: 'createdTs',
      order: -1
    }
  }
});

export const { sessionsTable } = prefabs;

export default prefabs;
